export default function contactFormSuccess() {
    const wpcf7Elm = document.querySelector('.wpcf7');
    const successLayer = document.querySelector('.contact-form__success');

    wpcf7Elm.addEventListener(
        'wpcf7mailsent',
        function() {
            successLayer.classList.add('shown');
            setTimeout(() => {
                successLayer.classList.remove('shown');
            }, 3000);
        },
        false
    );
}
